module.exports = __webpack_public_path__ + "media/bgcMovie.d384a6ca.mp4";